import { createSlice } from '@reduxjs/toolkit'

const initialState = {status: false}
  
export const sidebarSlice = createSlice({
    name: 'sidebar',
    initialState,
    reducers: {
        openSidebar: (state) => {
            state.status = true
        },
        closeSidebar: (state) => {
            state.status = false
        }
    },
})

// Action creators are generated for each case reducer function
export const { openSidebar, closeSidebar } = sidebarSlice.actions

export default sidebarSlice.reducer